import * as React from "react";
import { RouteComponentProps } from "@reach/router";
import { Field, FormikProps } from "formik";
import { ClassName } from "../support/className";
import BootstrapStyles from "../css/bootstrap.module.css";
import { FormValues } from "../support/FormValues";
import { FieldCommonFirms } from "../components/FieldCommonFirms";
import { StepHeader } from "../components/StepHeader";
import { FieldNameEnum } from "../support/FieldNameEnum";
import { useScrollTop } from "../customHooks/scrollTop";

interface CurrentFirmProps extends RouteComponentProps {
  formikBag: FormikProps<FormValues>;
}

const stepHeaderText = "What firm are you transferring the account from?";
const stepNoteText = `We recommend having a recent statement from this firm ready to reference.`;

const CurrentFirm = ({ formikBag: { values }, location }: CurrentFirmProps) => {
  useScrollTop(location);

  return (
    <div>
      <div className={ClassName.currentFirmWrapper}>
        <div className={BootstrapStyles.container}>
          <div className={BootstrapStyles.row}>
            <StepHeader stepHeader={stepHeaderText} stepNote={stepNoteText} />
          </div>
          <div className={BootstrapStyles.row}>
            <Field
              name={FieldNameEnum.currentFirm}
              component={FieldCommonFirms}
            />
          </div>
          <div className={BootstrapStyles.row}>
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentFirm;
